//
// Scroll to target
// --------------------------------------------------
// Used to smooth scroll to target, able to set offset if required (e.g. navigation is fixed)
// Prevents hashes being added to url for same page scroll to

import { PageUtils } from "./helpers/page-utils";
window.addEventListener('load', () => {
    document.querySelectorAll('button[data-destination]').forEach((scrollButton) => {
        const destination = scrollButton.dataset.destination;
        const targetElement = document.querySelector(destination);
        const formAlter = scrollButton.dataset.formAlter;

        if (targetElement) {
            scrollButton.addEventListener('click', () => {
                PageUtils.scrollToTarget(targetElement);
                if (formAlter) {
                    const formHeading = targetElement.querySelector('.form-heading');
                    const myKitStatsField = targetElement.querySelector('input[form-input-myKitStats]');

                    if (formHeading) {
                        formHeading.textContent = formAlter;
                    }
                    if (formHeading.lowercase === 'request a quote' && myKitStatsField) {
                        const section = scrollButton.closest('section');
                        const cards = section.querySelectorAll('[data-my-kit-card]');
                        const kitStats = [];

                        cards.forEach(card => {
                            const title = card.querySelector('h3')?.textContent?.trim() || '';
                            const imageSrc = card.querySelector('img')?.src || '';
                            const numberValue = parseFloat(card.querySelector('input')?.value || '0');

                            if (numberValue > 0) {
                                kitStats.push({
                                    title,
                                    value: numberValue,
                                    image: imageSrc
                                });
                            }
                        });

                        myKitStatsField.value = JSON.stringify(kitStats);
                    } else if (myKitStatsField) {
                        myKitStatsField.value = '';
                    }
                }
            });
        }
    });
});